"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_1 = require("react");
var socket_io_client_1 = __importDefault(require("socket.io-client"));
var encoding_1 = require("@cosmjs/encoding");
var proto_signing_1 = require("@cosmjs/proto-signing");
var cosmwasm_stargate_1 = require("@cosmjs/cosmwasm-stargate");
var constants_1 = require("../constants");
var socket = (0, socket_io_client_1.default)(constants_1.REACT_APP_SOCKET_URL, {
    transports: ["websocket"],
    withCredentials: true
});
var getClient = function (key) {
    if (key === void 0) { key = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var privateKey, wallet, client, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(key.length > 0)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    privateKey = (0, encoding_1.toUtf8)(key);
                    return [4 /*yield*/, proto_signing_1.DirectSecp256k1Wallet.fromKey(privateKey, 'juno')];
                case 2:
                    wallet = _a.sent();
                    return [4 /*yield*/, cosmwasm_stargate_1.SigningCosmWasmClient.connectWithSigner(constants_1.REACT_APP_RPC, wallet)];
                case 3:
                    client = _a.sent();
                    return [2 /*return*/, {
                            wallet: wallet,
                            client: client
                        }];
                case 4:
                    e_1 = _a.sent();
                    console.log("wallet connection failed", e_1);
                    return [2 /*return*/, undefined];
                case 5: return [2 /*return*/, undefined];
            }
        });
    });
};
var useConnectWallet = function () {
    var _a = (0, react_1.useState)(), address = _a[0], setAddress = _a[1];
    var _b = (0, react_1.useState)(), cookie = _b[0], setCookie = _b[1];
    var _c = (0, react_1.useState)(""), client = _c[0], setClient = _c[1];
    var _d = (0, react_1.useState)(""), wallet = _d[0], setWallet = _d[1];
    var count = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(function () {
        socket.on("getTokenRes", function (msg) {
            if (msg.success && socket.id === msg.id) {
                getClient(msg.token).then(function (cli) {
                    setClient(cli.client);
                    setWallet(cli.wallet);
                });
            }
        });
        socket.on("error", function () {
            console.log("socket disconnected");
        });
        return function () {
            socket.off("connect");
            socket.off("disconnect");
        };
    }, []);
    var getToken = function () {
        var cookie = js_cookie_1.default.get("cookie");
        cookie && setCookie(cookie);
        cookie && socket.id && socket.emit("getToken", { cookie: cookie, id: socket.id });
    };
    var initialize = function () {
        getToken();
        var address = js_cookie_1.default.get("address");
        address && setAddress(address);
    };
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            if (!client && count.current <= 7) {
                initialize();
                count.current += 1;
            }
        }, 1000);
        return function () { return clearInterval(interval); };
    }, []);
    (0, react_1.useEffect)(function () {
        var handler = function (event) {
            if (event.data.address) {
                setAddress(event.data.address);
                setCookie(event.data.cookie);
                js_cookie_1.default.set("cookie", event.data.cookie, { sameSite: 'none', secure: true, domain: '.loop.fans' });
                js_cookie_1.default.set("address", event.data.address, { sameSite: 'none', secure: true, domain: '.loop.fans' });
                getToken();
            }
        };
        window.addEventListener("message", handler);
        return function () { return window.removeEventListener("message", handler); };
    }, []);
    var login = function () {
        var url = constants_1.REACT_APP_SOCKET_URL + '/login/federated/google';
        var newWindow = window.open(url, 'name', 'height=600,width=600');
        newWindow === null || newWindow === void 0 ? void 0 : newWindow.postMessage(JSON.stringify({ obj: window }), '*');
        if (window.focus) {
            newWindow.focus();
        }
        return false;
    };
    var logout = function () {
        js_cookie_1.default.set("cookie", "", { sameSite: 'none', secure: true, domain: '.loop.fans' });
        js_cookie_1.default.set("address", "", { sameSite: 'none', secure: true, domain: '.loop.fans' });
        setAddress(undefined);
        setCookie(undefined);
    };
    return { logout: logout, cookie: cookie, address: address, client: client, login: login, wallet: wallet };
};
exports.default = useConnectWallet;
